// extracted by mini-css-extract-plugin
module.exports = {"container":"Join_container__1nXtd","title":"Join_title__UOg6u","desc":"Join_desc__37B-I"};